var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7092_41043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.4996V10.9246C7.51953 9.63221 7.79388 8.35634 8.30735 7.17013C8.82081 5.98392 9.56329 4.91069 10.4922 4.01193C11.4212 3.11316 12.5184 2.40653 13.7209 1.93253C14.9234 1.45852 16.2076 1.22646 17.5 1.24963V1.24963C18.7924 1.22646 20.0766 1.45852 21.2791 1.93253C22.4816 2.40653 23.5788 3.11316 24.5078 4.01193C25.4367 4.91069 26.1792 5.98392 26.6927 7.17013C27.2061 8.35634 27.4805 9.63221 27.5 10.9246V17.4996",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.75H6.25C6.58152 13.75 6.89946 13.8817 7.13388 14.1161C7.3683 14.3505 7.5 14.6685 7.5 15V22.5C7.5 22.8315 7.3683 23.1495 7.13388 23.3839C6.89946 23.6183 6.58152 23.75 6.25 23.75H3.75C3.08696 23.75 2.45107 23.4866 1.98223 23.0178C1.51339 22.5489 1.25 21.913 1.25 21.25V16.25C1.25 15.587 1.51339 14.9511 1.98223 14.4822C2.45107 14.0134 3.08696 13.75 3.75 13.75V13.75Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 23.75H28.75C28.4185 23.75 28.1005 23.6183 27.8661 23.3839C27.6317 23.1495 27.5 22.8315 27.5 22.5V15C27.5 14.6685 27.6317 14.3505 27.8661 14.1161C28.1005 13.8817 28.4185 13.75 28.75 13.75H31.25C31.913 13.75 32.5489 14.0134 33.0178 14.4822C33.4866 14.9511 33.75 15.587 33.75 16.25V21.25C33.75 21.913 33.4866 22.5489 33.0178 23.0178C32.5489 23.4866 31.913 23.75 31.25 23.75V23.75Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30.625C23.8261 30.625 25.0979 30.0982 26.0355 29.1605C26.9732 28.2229 27.5 26.9511 27.5 25.625V20",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30.625C22.5 31.4538 22.1708 32.2487 21.5847 32.8347C20.9987 33.4208 20.2038 33.75 19.375 33.75H15.625C14.7962 33.75 14.0013 33.4208 13.4153 32.8347C12.8292 32.2487 12.5 31.4538 12.5 30.625C12.5 29.7962 12.8292 29.0013 13.4153 28.4153C14.0013 27.8292 14.7962 27.5 15.625 27.5H19.375C20.2038 27.5 20.9987 27.8292 21.5847 28.4153C22.1708 29.0013 22.5 29.7962 22.5 30.625Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7092_41043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.c5786ff1de7ef5a97bb5b91a761f273a.svg";
export { ForwardRef as ReactComponent };